import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userEmergencyContact, errors } = copy;

export const fields: IFormFields = [
  {
    name: "firstname",
    label: userEmergencyContact.fields.firstname,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "lastname",
    label: userEmergencyContact.fields.lastname,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "phoneNumber",
    label: userEmergencyContact.fields.phone,
    type: IFieldType.phone,
    validation: {
      required: errors.required,
    },
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "email",
    label: userEmergencyContact.fields.email,
    type: IFieldType.email,
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "note",
    label: userEmergencyContact.fields.note.title,
    note: userEmergencyContact.fields.note.note,
    type: IFieldType.text,
    style: {
      gridColumn: "span 2",
    },
  },
];
